import React from "react";
import "./Hamburger.scss";
import { useDispatch, useSelector } from "react-redux";
import { ToggleSidebar } from "../../Redux/Toggles/Toggles.actions";

const Hamburger = () => {
  const dispatch = useDispatch();
  const showStatus = useSelector((state) => state.toggles.sidebar);

  const toggle = () => {
    if (!showStatus) {
      dispatch(ToggleSidebar());
      return;
    }

    document.getElementsByClassName("Sidebar")[0].classList.add("hide");

    setTimeout(() => {
      dispatch(ToggleSidebar());
    }, 450);
  };

  return (
    <div
      className={` ${showStatus ? "cross" : null} Hamburger`}
      onClick={toggle}
    >
      <div className="line l1"></div>
      <div className="line l2"></div>
      <div className="line l3"></div>
    </div>
  );
};

export default Hamburger;
